import React from "react";

const Bash_Functions = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Functions</h2>
    </div>
  );
};

export default Bash_Functions;
